import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MasterPage from "../master-page";
import { getAssessments } from "../../actions/portal.action";
import localizationService from "../../services/localization-service";

export const AssessmentsPage = () => {
  const dispatch = useDispatch();
  const selectedlang = useSelector((state) => state.account.lang);

  const assessmentsRaw = useSelector((state) => state.portal.assessments);
  const assessments = Array.isArray(assessmentsRaw) ? assessmentsRaw : [];

  useEffect(() => {
    dispatch(getAssessments());

    if (window.innerWidth < 1300) {
      const mainContainer = document.querySelector("main.main-app-container");

      if (mainContainer) {
        mainContainer.classList.add("mobile");
      }

      return () => {
        if (mainContainer) {
          mainContainer.classList.remove("mobile");
        }
      };
    }
  }, [dispatch]);

  return (
    <MasterPage>
      <div
        className={
          assessments.length === 0
            ? "alert alert-warning p-4 rounded-lg bg-yellow-50 border border-yellow-200 text-yellow-800"
            : "max-w-4xl mx-auto px-4"
        }
      >
        {assessments.length === 0 ? (
          <p className="text-center font-semibold text-gray-600">
            {localizationService.getLocalizationValue(
              "noAssessments",
              selectedlang,
            )}
          </p>
        ) : (
          assessments.map((as, asIndex) => (
            <div
              key={asIndex}
              className="bg-white rounded-xl shadow-md my-4 border border-gray-200"
            >
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center px-4 py-3 border-b border-gray-100 gap-2">
                <h5 className="sm:text-lg md:text-xl uppercase font-semibold text-gray-800">
                  {localizationService.getLocalizationValue(
                    "currentAssessmentsTitle",
                    selectedlang,
                  )}
                </h5>
                <p className="text-gray-600">
                  {localizationService.getLocalizationValue(
                    "dueDate",
                    selectedlang,
                  )}
                  : {as.dueDate || "N/A"}
                </p>
              </div>

              <div className="p-4">
                <div className="bg-[#f5f7eb] border border-green-400 rounded-lg p-4 mb-2">
                  <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div className="text-gray-700">
                      {localizationService.getLocalizationValue(
                        "completeAssessmentsMsg",
                        selectedlang,
                      )}
                    </div>
                    <a
                      href={as.assessmentURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full md:w-auto px-4 py-2 bg-[#9aa82d] text-white rounded-lg hover:bg-[#7d8a1f] text-center transition"
                      style={{ overflow: "unset", textDecoration: "none" }}
                    >
                      {localizationService.getLocalizationValue(
                        "completeAssessmentsBtn",
                        selectedlang,
                      )}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </MasterPage>
  );
};
